import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Typography, Grid, Divider, CircularProgress } from '@mui/material';
import placeholderItem from 'styles/assets/placeholder/placeholder.gif';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

export default function CuponsComponent(props) {
  const { promotionList, downloadImageOnLoad } = props;
  const { t } = useTranslation();

  return (
    <div>
      {promotionList === null ? (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress style={{ padding: '150px 20px', boxSizing: 'content-box' }} />
        </div>
      ) : (
        <div>
          {promotionList.length > 0 ? (
            <div>
              {promotionList.map((row, i) => {
                const id = row.id;

                return (
                  <div key={id}>
                    <Grid container spacing={3} style={{ width: '100%' }}>
                      <Grid size={{ md: 5, lg: 5 }}>
                        <Link
                          onClick={() =>
                            trackEventMatomoElementId(
                              'Estabelecimento',
                              'tocar',
                              'listaDePromocoes',
                              id
                            )
                          }
                          to={{
                            pathname: '/oferta/',
                            search: '?id=' + id,
                            state: row,
                          }}
                          style={{ textDecoration: 'none' }}
                        >
                          <img
                            alt="promo"
                            className="img-radius"
                            width="100%"
                            src={
                              row.downloadedThumbnail === undefined
                                ? placeholderItem
                                : row.downloadedThumbnail
                            }
                            onLoad={() => downloadImageOnLoad('promotionList', i)}
                          />
                        </Link>
                      </Grid>
                      <Grid size={{ md: 7, lg: 7 }}>
                        <Link
                          onClick={() =>
                            trackEventMatomoElementId(
                              'Estabelecimento',
                              'tocar',
                              'listaDePromocoes',
                              id
                            )
                          }
                          to={{
                            pathname: '/oferta/',
                            search: '?id=' + id,
                            state: row,
                          }}
                          style={{ textDecoration: 'none' }}
                        >
                          {/* <Typography color="primary" variant="h6">
															{row.establishmentName}
														</Typography> */}
                          <Typography
                            gutterBottom
                            variant="subtitle1"
                            style={{ color: 'black', fontWeight: 'bolder' }}
                          >
                            <i>{row.title}</i>
                          </Typography>
                          <Typography color="secondary" className="limit-text" variant="caption">
                            {row.description}
                          </Typography>
                        </Link>
                      </Grid>
                    </Grid>
                    {i < Object.keys(promotionList).length - 1 ? (
                      <Divider style={{ margin: '20px 0px', float: 'right' }} width="80%" />
                    ) : null}
                  </div>
                );
              })}
            </div>
          ) : (
            <Typography
              style={{
                textAlign: 'center',
                fontSize: '20px',
                color: '#8B8B8B',
              }}
              color="secondary"
              className="limit-text"
              variant="caption"
            >
              {t('general.establishment_without_coupons')}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
}
